import React from 'react';
import './App.css';
import BlogEntry from './BlogEntry';
import { agg_issues, calc_sum, calc_avg } from './Common';

const OMNIBUS_LIST = [
  {
    'title': 'Poe Dameron Omnibus',
    'summary': `This long-awaited omnibus collects the entirety of the Poe Dameron series. The first 25 issues lead in to Poe Dameron's search for Lor San Tekka that we see in the very beginning of Episode VII: The Force Awakens. The last six issues take place shortly after Episode VIII: The Last Jedi. 

    The whole series is written by Charles Soule, with art in the first half by Phil Noto and the latter half by Angel Unzueta. Their art styles are quite different, but since the issues aren't constantly switching between their styles I didn't find the changes too jarring. 

    The story in this book is pretty solid, covering a lot of important backstory about Poe leading up to the sequel trilogy. I really liked seeing his quest to find Lor San Tekka and this series has greatly increased my enjoyment of Episode VII: The Force Awakens. However, as this was coming out at the same time as the movies they wree pretty limited in what this series could do, so the plots are pretty small-scale in nature and don't have huge implications for the overall canon. Despite that, Soule was able to develop great side characters and an incredible antagonist in Agent Terex, which I believe still makes this series a worthwhile read. If you enjoyed Poe's character in the sequel trilogy or want to see more sequel era worldbuilding I'd recommend this omnibus to add much needed development to the era. 
    `,
    'amazon': 'https://amzn.to/49Hj9kz',
    'release_date': '2026-09-08',
    'included_issues': [
      756,
      757,
      758,
      759,
      760,
      761,
      762,
      763,
      764,
      765,
      766,
      767,
      768,
      769,
      770,
      771,
      772,
      773,
      774,
      775,
      776,
      777,
      778,
      779,
      780,
      781,
      782
    ],
    'img': 800014,
  },
  {
    'title': 'Dark Droids Omnibus',
    'summary': `This omnibus includes the entire Dark Droids event, as well as the conclusions to all four ongoing series between Episode V: The Empire Strikes Back and Episode VI: Return of the Jedi. If you've also picked up the War of the Bounty Hunters, Crimson Reign, and Hidden Empire Omnibus' you'll have all issues of the four ongoing series except for first 10-12 issues. There's no guarantee Marvel would ever go back to make an omnibus of the start of the era, but regardless these four event omnibus provide a very comprehensive way of collecting the era. 

    Overall I thought the Dark Droids event was well executed and the ongoing series had excellent tie-ins. The main event miniseries has fantastic art by Luke Ross and is pretty successful at bringing a splash of horror into the Star Wars universe. 

    The Bounty Hunters issues are fantastic and one of the high points of this collection, with the Dark Droids issues showing the crew trying to help Valence recover his memories followed by a few issues to conclude the series. The Star Wars series issues were also excellent, focusing on Lando trying to help Lobot as we've often seen in Soule's writing. The series also delivers a thrilling conclusion that does an incredible job wrapping up the whole 50 issue series. 

    The Doctor Aphra issues for Dark Droids were pretty good and the series managed to land a pretty satisfying ending as well. The Darth Vader tie-in issues for the event were a pretty cool demonstration of his power, but I ultimately found the ending to the series to be a bit of a letdown. This Vader series has never really managed to connect with me so I'm not surprised it was my least favourite conclusion as well. 

    In summary, this massive Omnibus covers the unique and exciting Dark Droids crossover while also providing the conclusion to each ongoing series. For anyone who's been purching the other event omnibus this is a must-buy to complete your collection. If you haven't been following these series at all you'll likely still find these stories entertaining, but the conclusions will be much more satisfying the more prior issues you've read. 
    `,
    'amazon': 'https://amzn.to/49Gim39',
    'release_date': '2026-08-18',
    'included_issues': [
      1034,
      1011,
      1006,
      1000,
      1045,
      1017,
      1046,
      1086,
      1117,
      1016,
      1090,
      1018,
      1047,
      1091,
      1118,
      1087,
      1049,
      1050,
      1051,
      1048,
      1094,
      1092,
      1095,
      1088,
      1063,
      1119,
      1089,
      1120,
      1093,
      1154,
      1121,
      1171,
      1122,
      1123,
      1124,
      1125,
      1126,
      1127,
      1226,
      1128,
      1129,
      1227,
      1228,
      1229,
      1230,
      1231,
      1259,
      1260,
      1261,
      1262,
      1263,
    ],
    'img': 800013,
  },
  {
    'title': 'Hidden Empire Omnibus',
    'summary': `This omnibus concludes the Crimson Dawn trilogy that began with the War of the Bounty Hunters Omnibus and continued in the Crimson Reign Omnibus. The Hidden Empire miniseries shows the culmination of Qi'ra's planning as she takes the fight to the Empire. It's a pretty solid story that gave a surprising amount of focus to Chanath Cha, who previously appeared in the Lando miniseries many years prior.
    
    The majority of the other issues in this omnibus have little connection to the Hidden Empire storyline, with the exception of the Doctor Aphra issues that tie-in pretty closely. The plot point of Doctor Aphra's possession by the Spark Eternal plays a pretty important role in the Hidden Empire story so the Aphra issues were very interesting to me. I also enjoyed the Bounty Hunter issues in this collection, where we see the gang of mercenaries targeted by Inferno Squad. As someone who played the Star Wars Battlefront II campaign I found it very satisfying to see the characters appear again in the comics and were as intimidating as they deserved to be. 

    The first three issues of the Star Wars series in this volume were pretty exciting to me, with a nice connection to the Crimson Dawn plot and a great story involving the Second Death Star. There's also a fantastic story about Luke and kyber crystals that was a lot of fun. The Darth Vader issues bring Sabe to the forefront of the story once again as Vader faces off against Wat Tambor's grandon, Jul. I thought these issues were decent but nothing special, which is also how I felt about this Darth Vader series in general. 

    Overall I'd say there's a lot of great content in this omnibus. If you've picked up the Crimson Reign Omnibus you'll definitely want this one to continue the story. 
    `,
    'amazon': 'https://amzn.to/44YJYOz',
    'release_date': '2026-02-17',
    'included_issues': [
      690,
      905,
      906,
      907,
      908,
      904,
      961,
      962,
      963,
      964,
      911,
      912,
      913,
      884,
      885,
      886,
      887,
      888,
      923,
      889,
      1033,
      924,
      890,
      925,
      891,
      926,
      927,
      1001,
      1002,
      914,
      915,
      916,
      917,
      1007,
      909,
      1012,
      1013,
      1008,
      1009,
      1010,
    ],
    'img': 800012,
  },
  {
    'title': 'Crimson Reign Omnibus',
    'summary': `This story builds on the Qi'ra and Crimson Dawn plot introduced in War of the Bounty Hunters. The Crimson Reign miniseries shows how Qi'ra built her power base and recruited allies to prepare for her fight against the Empire. All the tie-ins from ongoing series show the impact that the return of Crimson Dawn has cross the galaxy. Although this is called a crossover, it is far less interconnected than War of the Bounty Hunters and the stories in each series are pretty independent. 

    The Star Wars issues are really good, with a mix of both Luke's adventures learning more about the Jedi and a Leia story where she faces off against Commander Zahra. The Bounty Hunters issues were also great, including an issue focused on Dengar that was pretty memorable. The Doctor Aphra issues are where the series started to find it's footing for me, and introduce the Spark Eternal storyline that continues through the Hidden Empire event. The Vader issues include Sabe's return to the series as the Sith Lord attempts to identify traitors loyal to Crimson Dawn.

    The story arcs in this omnibus are all solid and the writer's of the ongoing series all did an excellent job using the return of Crimson Dawn to drive their own stories forward. My only complaint is that collections like these make it very difficult to collect all issues of the ongoing series in hardcover without any double dipping. However, being able to read the entire crossover together in a single book can be a great reading experience, and the gaps before or after event hardcovers can always be filled with paperbacks. I am really happy they continued Qi'ra's story in the comics so I'll definitely be picking this up to complement the War of the Bounty Hunters omnibus. 

    Note that the listing for this omnibus on Amazon and many other sites is incomplete. This omnibus includes Bounty Hunters (2020) #25-26 and Darth Vader (2020) #25-27 even though many sites do not include these in the contents. 
    `,
    'amazon': 'https://amzn.to/3LStEo8',
    'release_date': '2025-04-08',
    'included_issues': [
      663,
      680,
      681,
      664,
      665,
      892,
      893,
      894,
      895,
      896,
      897,
      898,
      682,
      683,
      684,
      685,
      686,
      687,
      688,
      689,
      675,
      676,
      677,
      678,
      679,
      899,
      900,
      901,
      902,
      903,
      666,
      667,
      668,
      669,
      670,
      671,
      910,
    ],
    'img': 800009,
  },
  {
    'title': 'Star Wars by Gillen & Pak Omnibus',
    'summary': `In this collection Gillen proves once again how incredible of a Star Wars writer he is. He elegantly weaves plots throughout the series, with every issue having some added significance later in the story.
      
      It opens with a return to Jedha in the wake of it's partial destruction in Rogue One. It feels so right seeing Han, Luke, and Leia on Jedha that it feels like this story was always meant to be told. The rest of his arcs gave a similar feeling, each one so authentically Star Wars that it feels like a movie. In addition to connections to Rogue One, this series also references characters from The Clone Wars and Rebels that really help tie the universe together in an organic way.
  
      Pak's story arc towards the end is good enough, but reading it right after the brilliant climax of Gillen's run just emphasizes how average it is. At least it has Noto's unique art style to help maintain our attention. On the topic of art, it must also be mentioned that the artwork is incredibly weak in the first half of Gillen's run. It's quite tragic that the such a strong writer didn't get an artist of a similar calibre, but at least the second half of his run had much better artistic talent. However, it must be emphasized that the last half of Gillen's run is peak Star Wars and those issues alone make this collection worth buying.
      `,
    'amazon': 'https://amzn.to/3yx9lJH',
    'release_date': '2024-04-23',
    'included_issues': [
      526,
      527,
      528,
      529,
      530,
      531,
      532,
      533,
      534,
      535,
      536,
      537,
      538,
      539,
      540,
      541,
      542,
      543,
      544,
      545,
      546,
      547,
      548,
      549,
      550,
      551,
      552,
      553,
      554,
      555,
      556,
      567,
      568,
      569,
      570,
      571,
      572,
      573,
      574,
      424,
      1032,
    ],
    'img': 800002,
  },
  {
    'title': 'The High Republic Phase 3 Omnibus',
    'summary': `This omnibus starts off with the Shadows of Starlight miniseries, which covers some of the biggest events in the year gap between Phase 1 and Phase 3. Each issue focuses on different characters, so the amazing artwork provides so much visual context for character appearances as we enter Phase 3. It does an excellent job kicking off the phase, introducing some crucial plot points that are continued in the first novel, The Eye of Darkness.
    
    Next up is the ten issue High Republic (2023) series. The series closely follows Keeve, Sskeer, and Lourna as they attempt to fight back against the Nihil. It also features the return of Tey Sirrek introduced in the Phase 2 series, which helped the three phases of comics together. This series was very solid, both in terms of storytelling and artwork, and was probably my favourite of the three phases of High Republic ongoings.
    
    Finally, the Fear of the Jedi miniseries and The Finale one-shot conclude the story. The miniseries was a thrilling climax to the past five years of High Republic comics, as we see Keeve take a leadership position in the final battle against the Nihil. Although I would have liked more of the characters from the novels to appear in this omnibus, it was also very satisfying to see Keeve's full journey from Padawan to Marshal. I love the High Republic era and these comics are some of the best it has to offer, so I'd highly recommend this for anyone who's been following the story.`,
    // 'amazon': 'https://amzn.to/3WTcOfy',
    'release_date': '2026-04-30',
    'included_issues': [
      1052,
      1053,
      1054,
      1055,
      1044,
      1130,
      1131,
      1132,
      1159,
      1160,
      1161,
      1162,
      1163,
      1164,
      1316,
      1322,
      1323,
      1324,
      1325,
      1326,
      1361,
    ],
    'img': 800011,
  },
  {
    'title': 'The High Republic Phase 2 Omnibus',
    'summary': `Coming in at just 14 issues, this is the smallest Star Wars collection with the Omnibus branding. These stories cover Phase 2 of the High Republic, including the main comic series and The High Republic: The Blade miniseries. 
      
      The main High Republic series has a pretty good story with excellent artwork. Although I wouldn't say you need to read any novels before this series, the story directly continues in the young adult novel Path of Vengeance. I would highly recommend picking up the novel to get a satisfying conclusion. 
      
      The Blade miniseries tells a great stand-alone story about Porter Engle many years before his appearance in the Light of the Jedi novel. It's an excellent read that packed a lot of action and emotion into just four issues. It also sets up a plot point continued in the novel The High Republic: The Eye of Darkness.`,
    'amazon': 'https://amzn.to/3WTcOfy',
    'release_date': '2024-11-12',
    'included_issues': [
      945,
      946,
      947,
      948,
      949,
      950,
      951,
      952,
      953,
      954,
      955,
      956,
      957,
      958,
    ],
    'img': 800007,
  },
  {
    'title': 'The High Republic Phase 1 Omnibus',
    'summary': `Kicking off a brand new era of Star Wars storytelling, this collects all the Marvel High Republic Phase 1 comics. Some fans were disappointed the Dark Horse High Republic issues weren't included, but a cross-publisher omnibus is incredibly rare and I much preferred the Marvel issues anyways. 
      
      What is required in addition to this omnibus, however, is the novels that establish many of the characters and plot points that are featured in these comics. There is no better way to start the High Republic than by reading the novel Light of the Jedi, which is an incredible introduction to the era. That is the only novel I'd say is strictly necessary reading, however I'd also recommend Into the Dark because it introduces a villain that appears frequently in this omnibus, and The Rising Storm because it's fantastic.
      
      Beyond the interdependence on other media, these are unique and fun stories to read. It's so refreshing to get stories about new characters in a new time period where we don't already know all of the details of how everything ends and who lives or dies. If you have no interest in reading books I'd recommend choosing a different omnibus, but it really looks incredible on the shelf next to Light of the Jedi.`,
    'amazon': 'https://amzn.to/44V4rSK',
    'release_date': '2023-10-17',
    'included_issues': [
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      24,
      26,
      33,
      34,
      35,
      42,
      31,
      36,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
    ],
    'img': 800006,
  },
  {
    'title': 'War of the Bounty Hunters Omnibus',
    'summary': `This omnibus collects Marvel's first major Star Wars crossover event, War of the Bounty Hunters. In the aftermath of Episode V: The Empire Strikes Back, Boba Fett is now in possession of Han Solo frozen in carbonite. Before he can deliver the bounty to Jabba's Palace however, it's stolen from him and he must compete with Darth Vader, Doctor Aphra, the Rebellion, and various other bounty hunters to get it back. 
  
      The issues from the main miniseries are excellent and tell a great story. Without giving too many spoilers, it follows up on some plots from a movie that I never expected to see in comics. The best stories are the ones that tie together various eras of the Star Wars universe in a natural way, and I'd say that's pulled off very well here. 
  
      The tie-in issues vary in quality, ranging from decent to amazing. For the most part you can enjoy them even without reading the prior issues, but there are quite a few new characters that were introduced in the earlier issues. For example, Valence is the main character of the Bounty Hunters series, so for someone who hasn't been reading it they may be a bit lost reading the issues in this collection. 
  
      Although this omnibus collects the entire event, it is the first story in a trilogy focused on the return of Crimson Dawn. If you enjoyed this omnibus, you'll likely want to pick up the Crimson Reign Omnibus and the Hidden Empire Omnibus that follow it. 
      `,
    'amazon': 'https://amzn.to/3QX9XP4',
    'release_date': '2022-12-13',
    'included_issues': [
      628,
      629,
      630,
      631,
      632,
      633,
      634,
      635,
      636,
      637,
      638,
      639,
      640,
      641,
      642,
      643,
      644,
      645,
      646,
      647,
      648,
      649,
      650,
      651,
      652,
      653,
      654,
      655,
      656,
      657,
      658,
      659,
      660,
      661,
      662,
    ],
    'img': 800008,
  },
  {
    'title': 'Doctor Aphra Omnibus Vol. 2',
    'summary': `This volume continues Doctor Aphra adventures in the period between Episode V: The Empire Strikes Back and Episode VI: Return of the Jedi. It has a new creative team, and although I don't consider it to be as good as her first series, it's still an enjoyable read. Early on it tries to focus on an entirely new supporting cast, who took longer to capture my interest than the characters in the previous series.
  
      However, my appreciation for this series grew over time and I really enjoyed the second half of this series starting with the Spark Eternal storyline. Unfortunately, this omnibus only collects the first 25 issues of a 40 issue series so you'll need to pick up the Doctor Aphra: Friends and Enemies Omnibus to get the rest of the story.`,
    'amazon': 'https://amzn.to/3KgN2L0',
    'release_date': '2023-08-29',
    'included_issues': [
      609,
      610,
      611,
      612,
      613,
      624,
      625,
      626,
      627,
      637,
      643,
      647,
      649,
      652,
      659,
      666,
      667,
      668,
      669,
      670,
      671,
      884,
      885,
      886,
      887,
    ],
    'img': 800005,
  },
  {
    'title': 'Doctor Aphra Omnibus Vol. 1',
    'summary': `This omnibus collects the entirety of Doctor Aphra's first comic series. Likely the most popular Star Wars character created by Marvel, Aphra's series explores unseen corners of the Star Wars galaxy through her role as an archeologist. In her adventures she leaves a trail of scams, double crosses, and broken hearts as she struggles to overcome her rogue nature.
      
      One of the highlights of this collection is the characters, both new and familiar, and their complex relationships. With multiple love interests, a reunion with a family member, and no shortage of former associates she's betrayed, there are so many entertaining character moments that make it hard to put this book down.
      
      The artwork is also quite impressive in this collection, with a style that fits the story perfectly and is pleasant to look at. However, there were some moments with no captions and the artwork is left to convey the action, but I couldn't tell what was happening and struggled to follow along.`,
    'amazon': 'https://amzn.to/3yzLrgI',
    'release_date': '2023-01-31',
    'included_issues': [
      484,
      485,
      486,
      487,
      488,
      489,
      492,
      494,
      496,
      497,
      498,
      499,
      500,
      501,
      507,
      508,
      509,
      510,
      511,
      512,
      513,
      514,
      515,
      516,
      517,
      518,
      519,
      520,
      521,
      522,
      523,
      524,
      525,
      557,
      558,
      559,
      560,
      561,
      562,
      563,
      564,
      565,
      566,
      432,
      433,
      445,
      453,
      461,
      468,
      472,
      490,
      491,
      493,
      1032,
    ],
    'img': 800004,
  },
  {
    'title': 'Doctor Aphra: Friends and Enemies Omnibus',
    'summary': `Collected in this volume is the second half of Alyssa Wong's Doctor Aphra series set between The Empire Strikes Back and Return of the Jedi, along with the Sana Starros miniseries that takes place concurrently with these issues. Despite not being called Doctor Aphra Volume 3, this directly continues from the Doctor Aphra Volume 2 Omnibus and thus is highly recommended for anyone who already purchased the second volume. 
    
    The story opens with Aphra's body possessed by the Spark Eternal as many of her friends, including Sana and Tolvan, work to rescue her. This story ties in directly with the Hidden Empire miniseries, so it would be worthwhile to pick up that paperback as well to read alongside this for the full story. Sana's miniseries takes place after that arc, and explores Sana's relationship with her family and their involvement with the Empire. The next Doctor Aphra issues have a fun story of her kidnapping Luke to help her explore a temple with plenty of mishaps along the way. 
    
    Next is the Dark Droids crossover issues, where droids across the galaxy are possessed and turn against their masters and friends. I believe these issues stand fairly well on their own, but if you enjoy the story and want to learn more you can look for the Dark Droids TPB. In the wake of another crossover there's just one issue left to wrap up the whole series, but it manages to deliver a pretty satisfying ending. Despite all the event tie-ins this book manages to tell a pretty solid continuously story, using the big events to advance the story rather than derail it.`,
    'amazon': 'https://amzn.to/4ch17VZ',
    'release_date': '2025-12-02',
    'included_issues': [
      888,
      889,
      890,
      891,
      1001,
      1002,
      918,
      919,
      920,
      921,
      922,
      1003,
      1004,
      1005,
      1006,
      1117,
      1118,
      1119,
      1120,
      1154,
    ],
    'img': 800010,
  },
  {
    'title': 'Darth Vader by Charles Soule Omnibus',
    'summary': `
    This is my absolute favourite Star Wars omnibus and I don't see it being outdone any time soon. It is packed with fantastic stories from cover-to-cover with four thrilling story arcs. 

    This series starts immediately after the events of Episode III: Revenge of the Sith and shows the beginning of Darth Vader's service to the Empire. It features so many essential Vader stories, like building his red lightsaber, meeting the Inquisitors, returning to Mon Cala, and even constructing his castle on Mustafar.

    Every issue in the 25 issue series has the same writer and artist, which gives the whole collection a very consistent experience. There is one annual included by a different creative team that is mildly enjoyable, but also somewhat frustrating in that it ends on a cliffhanger that is never followed up on. This is my top recommendation for a Star Wars omnibus, this series is everything a Star Wars fan could ask for in a Darth Vader comic. 
    `,
    'amazon': 'https://amzn.to/3ywStCZ',
    'release_date': '2022-01-26',
    'included_issues': [
      234,
      235,
      236,
      237,
      238,
      239,
      240,
      241,
      242,
      243,
      244,
      245,
      261,
      262,
      263,
      264,
      265,
      268,
      274,
      275,
      276,
      277,
      278,
      279,
      280,
      281,
    ],
    'img': 800000,
  },
  {
    'title': 'Star Wars by Jason Aaron Omnibus',
    'summary': `This series follows the adventures of Han, Luke, Leia, and Chewbacca shortly after Episode IV: A New Hope. These are fun, action-heavy adventures that seek to capture the feeling of the original trilogy. Though it's quite successful in that regard, it would have been nice to see more influence from the prequel trilogy. 

    The first two story arcs and the Vader Down crossover are incredible and must read for any Star Wars fans. The Journals of Old Ben Kenobi are also amazing flashbacks that should appeal to any fans of the old Jedi Master. The next two arcs are also great stories, particularly noteable for introducing the elite group of Stormtroopers known as SCAR Squadron. 
    
    Unfortunately the last few story arcs are not as great, with artwork that's hard to look at and stories that feel very inconsequntial. Despite having some rough patches, this is a great read and an excellent way to jump into Star Wars comics!
    `,
    'amazon': 'https://amzn.to/44SXGAQ',
    'release_date': '2022-05-03',
    'included_issues': [
      425,
      426,
      427,
      429,
      434,
      436,
      438,
      439,
      440,
      441,
      442,
      443,
      451,
      452,
      453,
      454,
      455,
      456,
      430,
      457,
      458,
      459,
      460,
      461,
      462,
      473,
      474,
      475,
      476,
      477,
      478,
      479,
      480,
      481,
      482,
      483,
      490,
      491,
      492,
      493,
      494,
      495,
      502,
      503,
      504,
      506,
      505,
    ],
    'img': 800001,
  },
  {
    'title': 'Darth Vader by Gillen & Larroca Omnibus',
    'summary': `This is a fantastic series that shows Vader's rise to power within the Empire between Episode IV: A New Hope and Episode V: The Empire Strikes Back. This series is famous for introducing the character Doctor Aphra, who quickly became a fan favourite. 
    
    Here we see a more strategic Vader, who uses various schemes to pursue his own agenda while also serving the Empire. The core plot of this series revolves around a doctor specialing in cybernetics who creates a group of enhanced soldiers he intends as Vader's replacements. Vader faces off against these agents throughout the series, as he seeks to eliminate his competition without leaving any evidence of murdering an Imperial resource.
    
    Although I critice Larroca's artwork in other omnibus on this page, his work is much better in this collection. However, the writing is certainly the selling point in this collection, with Gillen establishing himself as a top Star Wars writer and setting him up to return on the main Star Wars line shortly after.`,
    'release_date': '2022-04-27',
    'included_issues': [
      428,
      431,
      432,
      433,
      435,
      437,
      444,
      445,
      446,
      447,
      448,
      449,
      451,
      452,
      453,
      454,
      455,
      456,
      463,
      464,
      465,
      466,
      467,
      468,
      469,
      470,
      471,
      472,
    ],
    'img': 800003,
  },
]

class OmnibusGuide extends React.Component {
  constructor(props) {
    super(props);
    this.state = { sortField: 'sort_order' };
  }

  render() {
    const data = this.props.data;
    if (!data) {
      return null;
    }

    const aggregate_data = OMNIBUS_LIST.map(x => {
      const collection_data = this.props.data?.filter(media => x.included_issues.includes(media.media_id));
      const issue_list = agg_issues(collection_data);
      x['body'] = issue_list + '\n' + x['summary'];

      // create a single collection that aggregates all the contents
      const media_data = {
        release_date: x['release_date'],
        avg_rating: calc_avg(collection_data, 'avg_rating'),
        rating_count: calc_sum(collection_data, 'rating_count'),
        user_rating: calc_avg(collection_data, 'user_rating'),
        mediaIdList: collection_data.map(x => x.media_id),
        sort_order: Math.max(...collection_data.map(x => x.sort_order)),
        format: 'C',
      };
      x['data'] = media_data;

      return x
    });

    if (this.state.sortField === 'release_date') {
      aggregate_data.sort((a, b) => new Date(b['release_date']) - new Date(a['release_date']));
    } else if (this.state.sortField === 'sort_order') {
      aggregate_data.sort((a, b) => a['data'][this.state.sortField] - b['data'][this.state.sortField]);
    } else {
      aggregate_data.sort((a, b) => (b['data'][this.state.sortField] || 1) - (a['data'][this.state.sortField] || 1));
    }

    return (
      <div className="blog-inner">
        <div className="blog-header">
          <h1>Guide to Marvel's Star Wars Canon Omnibus</h1>
        </div>
        <div
          className='infopanel-inner'
          style={{ display: 'flex', justifyContent: 'space-evenly', borderColor: 'black' }}
        >
          <button
            className={`${this.state.sortField === 'release_date' ? 'selected' : ''}`}
            onClick={() => this.setState({ sortField: 'release_date' })}
          >
            Order by newest release
          </button>
          <button
            className={`${this.state.sortField === 'avg_rating' ? 'selected' : ''}`}
            onClick={() => this.setState({ sortField: 'avg_rating' })}
          >
            Order by highest rated
          </button>
          <button
            className={`${this.state.sortField === 'sort_order' ? 'selected' : ''}`}
            onClick={() => this.setState({ sortField: 'sort_order' })}
          >
            Order by timeline placement
          </button>
        </div>
        {
          aggregate_data.map(x => {
            return (
              <BlogEntry
                blogData={x}
                data={x.data}
                key={`recommended-${x.title}`}
                loggedIn={this.props.loggedIn}
                addRating={this.props.addRating}
              ></BlogEntry>
            )
          })
        }
      </div>
    );
  }
}

export default OmnibusGuide;
